import api from 'app/api';
import store from 'app/store';

const getResaleEventById = async (id, isSecondary, callback) => {
  const successCallback = ({ data }) => {

    store.dispatch({ type: 'RESALE_EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  const url = `/events/${id}?isSecondary=${isSecondary}`;

  await api.get(url, {
    id: 'get-event-by-id',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: () => callback({ failure: true }),
    },
  });
};

const getTicketDetails = async (eventId, categoryName, callback) => {
  const payload = {
    event: eventId,
    categoryName: categoryName,
  };

  const successCallback = ({ data }) => {
    // console.log(data);

    store.dispatch({ type: 'TICKET_DETAILS:SET', data });

    if (callback) callback(data);
  };

  await api.post('/tickets/details', payload, {
    id: 'get-ticket-details',
    success: {
      callback: successCallback,
    },
  });
};

const enableTicketAlerts = async(eventId, callback, failureCb) => {
  const successCallback = ({ data }) => {
    // console.log('Ticket alerts enabled: ',data);
    store.dispatch({ type: 'TICKET_ALERTS:SET', data });
    if (callback) callback(data);
  };

  await api.post(`/events/subscribe/${eventId}`, {}, {
    id:'enable-ticket-alerts',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: failureCb,
    },
  });
};

const disableTicketAlerts = async(eventId, callback, failureCb) => {
  const successCallback = ({ data }) => {
    // console.log('Ticket alerts disabled: ',data);
    store.dispatch({ type: 'TICKET_ALERTS:REMOVE', data });
    if (callback) callback(data);
  };

  await api.post(`/events/unsubscribe/${eventId}`, {}, {
    id:'disable-ticket-alerts',
    success: {
      callback: successCallback,
    },
    failure: {
      callback: failureCb,
    },
  });
};

const postGetInTouchAnalytics = async(ticketId) => {
  await api.put(`/tickets/getintouch/${ticketId}`, {}, {
    id:'post-get-in-touch',
  });
};

export { getResaleEventById, getTicketDetails,enableTicketAlerts, disableTicketAlerts, postGetInTouchAnalytics };
